<template>
    <loading-message
        v-if="OrderShowing && EmptyOrder"
        :message="$t('views.main.orders.order.loading_order')"
        class="my-5"></loading-message>
    <web-app-order v-else-if="Order.IsFromWebApp" :order="Order"></web-app-order>
    <warehouse-app-order v-else :order="Order"></warehouse-app-order>
</template>

<script>
    import WebAppOrder from "./WebAppOrder";
    import WarehouseAppOrder from "./WarehouseAppOrder";
    import LoadingMessage from "../../../components/LoadingMessage";

    export default {
        name: "Order",

        components: {
            WebAppOrder,
            WarehouseAppOrder,
            LoadingMessage,
        },

        data() {
            return {
                Order: null,
                OrderShowing: false,
            }
        },

        computed: {
            EmptyOrder() {
                return this.Order === null;
            },
            RouteOrderID() {
                return parseInt(this.$route.params.id);
            },
        },

        methods: {
            orderShow () {
                this.OrderShowing = true;

                this.$store.dispatch('orderShow', this.RouteOrderID).then(response => {
                    if(response.status === 200) {
                        this.Order = response.data.data;
                    } else {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.orders.order.loading_order_failed')
                        );
                    }
                })
                    .catch(() => {})
                    .then(() => {
                        this.OrderShowing = false;
                    });
            },
        },

        created() {
            this.orderShow();
        }
    }
</script>

<style scoped>

</style>
